module.exports = {"en":"English","it":"Italiano"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/availableLanguages.json
// module id = 1029
// module chunks = 1